import React from "react";
import {Box, Text} from "@reside/ui";
import {useParams} from "react-router";
import {useFetchResident} from "../../page-admin-residents/hooks/useFetchResident";
import {AdminLayoutFullHeightAndTwoCells} from "../../../atoms/admin-layout";
import {DocumentTitle} from "../../../atoms/document-title";
import {useEditResident} from "../hooks/useEditResident";
import {ResidentFormik} from "../atoms/ResidentFormik";
import {BackdropSpinner} from "../../../atoms/spinner";

export const PageAdminResidentsEdit = (): JSX.Element => {
  const {resident_uuid} = useParams<{resident_uuid: string}>();

  const {
    data: resident,
    isLoading,
    remove: clearStaleResident,
  } = useFetchResident(resident_uuid);
  const {mutate: editResident, isLoading: isEditing} = useEditResident(
    resident?.id,
  );

  return (
    <AdminLayoutFullHeightAndTwoCells>
      <BackdropSpinner active={isLoading || isEditing}>
        <Box position="relative">
          <DocumentTitle title="Reside - Admin - Edit Resident" />

          <Text fontSize="24px" fontWeight="bold">
            Edit Resident
          </Text>

          <ResidentFormik
            edit
            initialValues={{
              first_name: resident?.first_name ?? "",
              middle_name: resident?.middle_name ?? "",
              last_name: resident?.last_name ?? "",
              date_of_birth: resident?.date_of_birth ?? "",
              gender: resident?.gender ?? "",
              status: resident?.status,
            }}
            handleSubmit={args => {
              editResident(args);
              clearStaleResident();
            }}
            isPccResident={Boolean(resident?.pcc_patient_id)}
          />
        </Box>
      </BackdropSpinner>
    </AdminLayoutFullHeightAndTwoCells>
  );
};
